import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/35_winter_house/35_winter_house"
 * Contains 1 texture(s)
 */
export class Mobile35WinterHouseAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/35_winter_house/35_winter_house';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '35_winter_house.png'
    ] as const;
}
